import React from "react";
import {FormattedMessage, injectIntl} from "react-intl";
import isObject from "lodash/isObject";
import WithOverlay from "./withOverlayHoc";
import ExclamationMarkIcon from "../ui/icons/exclamationMarkIcon";
import {COLORS} from "../../colorThemes";
import FatalErrorRecoveryPopup from "../../misc/errorReporting/FatalErrorRecoveryPopup";

class MessageBox extends React.Component {

  displayName = 'MessageBox';

  getMessage = () => {
    const {intl} = this.props;
    const props = this.props.state || this.props;
    const message = props.message;
    // console.log("message", message);
    if (Array.isArray(message)) {
      return message.map((msg, msgIndex) => <p key={"msg"+msgIndex}>
        {intl.messages[msg] ? <FormattedMessage id={msg}/> : msg}
      </p>)
    } else if (isObject(message)) {
      return message.id
        ? <FormattedMessage id={message.id} values={{...message}}/>
        : message.message
          ? message.message
          : message.toString ? message.toString() : null
    } else if (message) { //string
      return intl.messages[message] ? <FormattedMessage id={message}/> : message.replace("Zip", "Postal")
    } else {
      return "Error";
    }
  };

  render() {
    const props = this.props.state || this.props;

    if (!props.visible) {
      return null
    }

    if (props.fatalErrorRecovery) {
      return <FatalErrorRecoveryPopup initialStage={props.fatalErrorRecoveryInitialStage}/>;
    }

    const bClass = props.error ? 'message-red-lable' : 'message-blue-lable';
    const hClass = props.error ? 'message-error-message-title' : 'message-system-message-title';
    const messageClass = (props.error ? 'message-system-text-red' : 'message-system-text-blue') +
      (props.inline ? ' message-system-text-inline' : '');
    let buttonsElements = [];
    if (props.buttons && props.buttons.length) {
      buttonsElements = props.buttons.map((b) => {
        return <MessageBoxButton button={b} key={b.text}/>;
      });
    } else {
      buttonsElements.push(
        <MessageBoxButton button={{
          color: "blue",
          text: "messageBox.defaultButton",
          click: () => {
            //TODO[Artem] add default close logic
          }
        }}/>
      );
    }

    if (props.newStyles) {
      return (
        <WithOverlay className="overlay--confirm">
          {(hideOverlay) => (
            <div className={"confirm-popup confirm-popup--message" + (props.error ? " confirm-popup--red" : "")
              + (props.title === "noInternetTitle" ? " confirm-popup--no-internet" : "")}>
              {props.showCloseButton ? (
                <button className="confirm-popup__close ui-close"
                        type="button"
                        aria-label="Close"
                        onClick={(e) => {
                          e.stopPropagation();
                          e.preventDefault();
                          hideOverlay(() => {
                            if (props.closeClick) {
                              props.closeClick();
                            }
                          })
                        }}/>
              ) : null}
              <div className="confirm-popup-title">
                <div className="confirm-popup-title__icon">
                  <ExclamationMarkIcon color={props.error || props.title === "noInternetTitle" ? COLORS.red : null}/>
                </div>
                <div className="confirm-popup-title__text">
                  <FormattedMessage id={props.title || "messageBox.defaultTitle"}/>
                </div>
              </div>
              <div className="confirm-popup-body">
                {this.getMessage()}
              </div>
              <div className="confirm-popup-buttons">
                {props.buttons && props.buttons.length ? props.buttons.map((button) => {
                  return (
                    <button className={"ui-button2 ui-button2--"+button.color}
                            key={button.text}
                            onClick={(e) => {
                              e.stopPropagation();
                              e.preventDefault();
                              hideOverlay(() => {
                                button.click();
                              })
                            }}>
                      <FormattedMessage id={button.text}/>
                    </button>
                  )
                }) : null}
              </div>
            </div>
          )}
        </WithOverlay>
      )
    }

    return (
      <div className="full-screen-wrapper">
        <div className="message-window-base">
          <div className={hClass}><FormattedMessage id="messageBox.defaultTitle"/></div>
          <div className={bClass}/>
          <div className={"message-system-text " + messageClass}>{this.getMessage()}</div>
          <div className="message-box-buttons message-box-buttons--modal">{buttonsElements}</div>
        </div>
      </div>
    )
  }
}

const MessageBoxButton = ({button}) => {
  return (
    <button className={"ui-button ui-button--"+button.color} onClick={(e) => {
      e.stopPropagation();
      e.preventDefault();
      button.click()
    }}>
      <span className="ui-button-text ui-button--uppercase">
        <FormattedMessage id={button.text}/>
      </span>
    </button>
  );
};

export default injectIntl(MessageBox);
